export enum Roles {}

export enum AspenPermissions {
    ACCESS = 'access:aspen',
    ADMIN = 'admin:aspen',
    MANAGE_CANDIDATES = 'manage:candidates'
}
